import React from 'react';
import { Clock, Plus, ArrowUp, DollarSign } from 'lucide-react';
import { BillingTransaction } from '../../services/billingService';
import { useAppSelector } from '../../store/hooks';
import TransactionTable from './TransactionTable';

interface RecentActivitiesProps {
  activities: BillingTransaction[];
  loading?: boolean;
}

const RecentActivities: React.FC<RecentActivitiesProps> = ({ activities, loading = false }) => {
  const { theme } = useAppSelector((state) => state.ui);

  if (loading) {
    return (
      <div className={`rounded-lg border p-8 text-center ${
        theme === 'dark' 
          ? 'bg-gray-900/80 border-gray-700/50' 
          : 'bg-white border-gray-200'
      }`}>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
      </div>
    );
  }

  if (activities.length === 0) {
    return (
      <div className={`rounded-lg border p-8 text-center ${
        theme === 'dark' 
          ? 'bg-gray-900/80 border-gray-700/50' 
          : 'bg-white border-gray-200'
      }`}>
        <Clock className={`h-12 w-12 mx-auto mb-4 ${
          theme === 'dark' ? 'text-gray-600' : 'text-gray-400'
        }`} />
        <p className={`text-lg font-medium ${
          theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
        }`}>
          No recent activities
        </p>
        <p className={`text-sm mt-2 ${
          theme === 'dark' ? 'text-gray-500' : 'text-gray-500'
        }`}>
          Top-ups and other transactions will appear here
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Clock className={`h-5 w-5 ${
          theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
        }`} />
        <h3 className={`text-lg font-semibold ${
          theme === 'dark' ? 'text-white' : 'text-gray-900'
        }`}>
          Recent Top-Ups
        </h3>
        <span className={`px-2 py-1 text-xs font-medium rounded ${
          theme === 'dark' 
            ? 'bg-gray-700 text-gray-300' 
            : 'bg-gray-100 text-gray-600'
        }`}>
          {activities.length}
        </span>
      </div>
      
      <TransactionTable
        transactions={activities}
        loading={false}
        showHostColumn={false}
      />
    </div>
  );
};

export default RecentActivities;

